import { Rpc } from "./rpc";
import { ValueWrapper } from "./ValueWrapper";

export class VacationRpc {

    public static listAll(year: number): Promise<ListAllResponse> {
        return Rpc.POST("/rpc/vacation/listAll", { year: year });
    }

    public static add(userId: number, halfDayType: THalfDayType, startDate: string, endDate: string, type: string, description: string): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/vacation/add", { 
            userId: userId,
            halfDayType: halfDayType,
            startDate: startDate,
            endDate: endDate,
            type: type,
            description: description
         });
    }

    public static delete(id: number): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/vacation/delete", {id: id });
    }

    private constructor() { }
}

export interface ListAllRequest {

    readonly year: number;

}

export interface ListAllResponse {

    readonly vacationTypes: VacationTypeDto[];
    readonly workDays: boolean[];
    readonly extraWorkDays: TExtraWorkDayType[][];
    readonly teams: TeamDto[];

}

export interface VacationTypeDto {

    readonly id: string;
    readonly name: string;
    readonly color: string;

}

export type TExtraWorkDayType = "EXTRA_WORK_DAY" | "HOLIDAY";

export interface TeamDto {

    readonly id: number;
    readonly name: string;
    readonly users: UserVacationsDto[];

}

export interface UserVacationsDto {

    readonly id: number;
    readonly name: string;
    readonly position: string;
    readonly vacations: VacationDto[];

}

export interface VacationDto {

    readonly id: number;
    readonly vacationType: string;
    readonly description: string;
    readonly startDate: number;
    readonly endDate: number;
    readonly halfDayType: THalfDayType;

}

export type THalfDayType = "FirstHalf" | "SecondHalf"; 